import type { UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { CreateFileDto } from '../generated/model';
import { request } from '../axios.ts';

export type TherapyComplianceStatus = 'YES' | 'NO';

export type UpdateTherapyComplianceDto = {
  date: string;
  therapyCompliance: TherapyComplianceStatus;
  file?: CreateFileDto | null;
};

type RequestOptions = Parameters<typeof request>[1];

export function updateTherapyComplianceByPatient(
  patientId: string,
  complianceId: string,
  data: UpdateTherapyComplianceDto,
  options?: RequestOptions,
) {
  return request<void>(
    {
      url: `/api/patients/${patientId}/therapy/compliance/${complianceId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data,
    },
    options,
  );
}

export function useUpdateTherapyComplianceByPatient(
  options?: UseMutationOptions<
    void,
    Error,
    { patientId: string; complianceId: string; data: UpdateTherapyComplianceDto }
  >,
): UseMutationResult<void, Error, { patientId: string; complianceId: string; data: UpdateTherapyComplianceDto }> {
  return useMutation({
    mutationFn: ({ patientId, complianceId, data }) =>
      updateTherapyComplianceByPatient(patientId, complianceId, data),
    ...options,
  });
}
